// extracted by mini-css-extract-plugin
export default {"skinsWrapper":"CardsSkins_skinsWrapper__ksYzg","mainSkin":"CardsSkins_mainSkin__XUElf","card":"CardsSkins_card__8jNuI"};